import SupportButton from "../../../atoms/buttons/SupportButton";
import LanguageDropdown from "../../../molecules/dropdowns/LanguageDropdown";
import IdentityPanel from "../../../molecules/layouts/auth/IdentityPanel";

const DesktopLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen">
      <div className="w-1/2 fixed top-0 left-0 h-screen flex flex-col">
        <IdentityPanel />
      </div>
      <div className="flex-1 flex flex-col bg-white overflow-y-auto ml-[50%] relative">
        <div className="p-8 flex justify-start">
          <LanguageDropdown />
        </div>
        <div className="flex-1">{children}</div>
        <div className="fixed bottom-8 right-8">
          <SupportButton />
        </div>
      </div>
    </div>
  );
};

export default DesktopLayout;
